import Icon from '@material-ui/icons/ContactMail';
import React from 'react';
import { CreateButton } from '../../../buttons';
import { EditDialog, Filter, ResourceList, ResourceShow } from '../../../controllers';
import { AddressField, TextField } from '../../../fields';
import { BooleanInput, CountrySelectInput, NestedReferenceInput, StateSelectInput, TextInput } from '../../../inputs';

export default {
  Icon,
  dialogs: {
    edit: props => (
      <EditDialog
        {...props}
      >
        <TextInput
          source="name"
          required
        />
        <TextInput
          source="address1"
          required
        />
        <TextInput
          source="address2"
        />
        <TextInput
          source="city"
          required
        />
        <StateSelectInput
          required
        />
        <TextInput
          source="zip_code"
          required
        />
        <CountrySelectInput
          required
        />
      </EditDialog>
    ),
    create: props => (
      <CreateButton
        fixedValue={{ organization_id: props.parentResource.id }}
        {...props}
      >
        <NestedReferenceInput
          filter={{ scope: 'account' }}
          source="user_id"
        />
        <TextInput
          source="name"
          required
        />
        <TextInput
          source="address1"
          required
        />
        <TextInput
          source="address2"
        />
        <TextInput
          source="city"
          required
        />
        <StateSelectInput
          required
        />
        <TextInput
          source="zip_code"
          required
        />
        <CountrySelectInput
          required
        />
      </CreateButton>
    ),
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <TextField
          source="name"
        />
        <AddressField />
      </ResourceList>
    ),
    show: props => (
      <ResourceShow
        {...props}
      >
        <TextField
          source="name"
        />
        <AddressField />
      </ResourceShow>
    ),

  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <BooleanInput
          label="Deleted"
          source="deleted"
        />
      </Filter>
    ),
  },
  resources: {
  },
};
